// extracted by mini-css-extract-plugin
export default {"overlayLabel":"pv_pw","overlayLabel_small":"pv_px"};